import { createContext } from 'react';

type SelectedTariffContext = {
  selectedTariffId: string;
  toggleSelectTariffId: (tariffId: string) => void;
};

export const SelectedTariffContext = createContext<SelectedTariffContext>({
  selectedTariffId: '',
  toggleSelectTariffId: () => {},
});
